export default {
  // success
  success: "Sucesso",
  success_add: "Registro adicionado com sucesso",
  success_active: "Status do registro alterado para ativo",
  success_bind_coverage_unity: "Registro(s) vinculado(s) com sucesso!",
  success_change_status: "Status alterado com sucesso!",
  success_delete: "Registro removido com sucesso",
  success_inactive: "Status do registro alterado para inativo",
  success_update: "Registro atualizado com sucesso",
  success_find: "Registro encontrado",
  success_seach: "Encontramos um registro com os dados fornecidos",
  success_linked_data: "Registro(s) vinculado(s) com sucesso!",
  success_observation: "Observação adicionada com sucesso!",
  success_send: "Informação enviada com sucesso!",

  // warnings
  warning: "Aviso",
  check_fields: "Verifique os campos e tente novamente",
  check_cpf_field: "Verifique o campo CPF e tente novamente",
  check_cns_field: "Verifique o campo CNS e tente novamente",
  check_field: "Verifique se digitou corretamente os dados e tente novamente",
  checkExactFields: "Campos",
  no_register_selected: "Selecione um registro para continuar",
  check_files: "Verifique os arquivos e tente novamente",
  check_file: "Verifique se o arquivo foi selecionado",
  out_coverage: "Fora da área de abrangência",
  patient_out_coverage: "Paciente fora da área de abrangência da unidade",
  address_out_coverage:
    "o endereço informado está fora da área de abrangência da unidade",
  try_remove_address_out_coverage:
    "Não é possível remover o endereço residencial do paciente, por estar fora da área de abrangência da unidade",
  empty_field: "O campo {field} está vazio, preencha para continuar",
  resource_not_available: "Recurso não disponível",
  select_one_option: "Selecione uma opção",
  only_one_profile:
    "Durante o processo de criação de conta, apenas um perfil é permitido",
  select_at_least_one_profile: "Selecione pelo menos um perfil para continuar",
  in_regulated_patients_page: "você já está na tela 'Paciente Regulados'",
  in_patients: "você já está na tela 'Pacientes'",

  // Erros
  error: "Erro",
  error_add: "Erro ao cadastrar registro",
  error_bind_coverage_unity: "Ocorreu um erro ao vincular a unidade",
  error_change_status: "Ocorreu um erro ao alterar o status",
  error_login: "Erro ao realizar login",
  error_not_defined: "Ops! Ocorreu um erro",
  error_password_not_match: "As senhas informadas não correspondem",
  error_query: "Erro ao realizar consulta",
  error_try_login: "Erro ao tentar realizar o login",
  error_update: "Erro ao atualizar registro",
  error_cep:
    "Não foi possível encontrar o endereço com o CEP fornecido. Verifique o campo e tente novamente",
  error_address: "Preencha os campos do endereço antes de continuar",
  error_address_home:
    "É necessário pelo menos um e somente um endereço residêncial",
  error_address_correspondence: "Já existe um endereço com correspondência",
  error_is_exist_data: "Já existe um registro correspondente",
  error_protocols_attachments:
    "Existe um ou mais anexos protocolares obrigatórios não preenchidos",
  error_is_exist: "Ops... O registro já existe",
  error_select_other: "Selecione outro registro para continuar",
  error_doc: "Selecione pelo menos um documento",
  error_genders: "Selecione pelo menos um sexo",
  error_age: "Verifique a validade das idades mínima e máxima informadas",
  error_occupation_sub_occupation:
    "Adicione pelo menos uma Ocupação/Sub-ocupação",
  error_delete: "Ocorreu um erro ao deletar o registro",
  check_captcha_input: "Verifique se o captcha foi preenchido corretamente",
  cep_out_date: "CEP desatualizado",
  invalid_cep:
    "Favor consultar na base dos correios um CEP válido com logradouro e bairro.",
  error_select_file: "Erro ao selecionar arquivo",
  error_max_size: "O arquivo excedeu o limite máximo de 2 MB",
  patient_not_found:
    "Não encontramos o paciente informado em nossa base de dados",
  error_send: "Erro ao enviar informação",
  error_files: "Envie pelo menos um anexo para continuar",
  error_patients: "Envie pelo menos um paciente para continuar",
  error_duplicate: "Não foi possível duplicar todos os itens",
  error_duplicate_one_or_more:
    "Por conta de um erro, um ou mais itens não foram criados/duplicados.",
  invalid_date: "Data inválida",
  check_date_input: "Verifique se a data foi preenchida corretamente",
  erro_dates_start_and_end:
    "A data fim deve ser igual ou maior que a data início",

  // others
  change_all_selection: "Marcar/Desmarcar todos os itens",
  select_all: "Marcar todos os itens",
  remove_all: "Desmarcar todos os itens",
  no_data: "Sem registros",
  name_and_birthDate:
    "Para buscar por data de nascimento é necessário informar o nome do paciente ou nome da mãe",
  register: "Verifique o campo 'Registro'",
  check_data_register: "Preencha o campos com 32 caracteres números",
  confirm_regulate_patient: "Deseja continuar a regulação do paciente?",
  remove_holiday:
    "O feriado selecionado será removido permanentemente. Após a confirmação, não será possível recuperar a data",
  waiting: "Aguarde",
  address_exist: "Endereço já cadastrado",
  existe_this_address:
    "Já existe um endereço cadastrado com o mesmo CEP e tipo",
  priority_level: "Selecione uma classificação de prioridade",
  no_patient: "Clique em {value} e busque por um paciente cadastro no sistema",
  error_setting_number_of_uses: "Erro ao definir quantidade de usos",
  number_of_uses_is_less:
    "A quantidade de usos é menor do que a quantidade definida na criação",
  rescheduling: "Informe o motivo para o reagendamento da solicitação",
  coordinate_is_not_valid: "A coordenada informada é inválida",
  check_the_value_you_are_trying_to_paste:
    "Verifique o valor que vocé está tentando colar",
};
